import {Component, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {of, Subscription} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {ProjectsService} from '../_services/projects.service';
import {SingleProjectModel} from '../_models/singleProject.model';
import {Options} from 'select2';
import {CurrentUser} from '../_models/currentUser.model';
// import {CountryISO, PhoneNumberFormat, SearchCountryField} from 'ngx-intl-tel-input';

const EMPTY_PROJECT: SingleProjectModel = {
    id: undefined,
    clientId: '',
    docNumber: '',
    contract: [],
    fiscalBill: [''],
    responsibleUserId: '',
    clientName: '',
    clientEmail: '',
    clientPhone: '',
    projectName: '',
    description: '',
    budget: 0,
    startDate: '',
    deadline: '',
    status: 'Draft',
    productList: ['']
};

@Component({
    selector: 'app-project-create-edit',
    templateUrl: './project-create-edit.component.html',
    styleUrls: ['./project-create-edit.component.scss']
})
export class ProjectCreateEditComponent implements OnInit, OnDestroy {


    id: any;
    project: SingleProjectModel;
    previous: SingleProjectModel;
    formGroup: FormGroup;

    singleOption: Options;
    multipleOption: Options;
    dataLoaded = false;
    companyResponsibleLoaded = false;
    productsLoaded = false;

    private subscriptions: Subscription[] = [];

    usersIdList = [];
    clientsArray = [];
    contractsArray = [];
    loadContracts: boolean;
    fiscalBillsArray = [];
    usersTeamArray = [];
    companyResponsibleArray = [];
    productsArray = [];

    formLoaded: boolean;


// Feedback Messages
    formResponse: boolean;
    formSent: boolean;
    successMsg = '';
    errorMsg = '';

    // Current User
    currentUser: CurrentUser;
    createdProjectId: string;

    // Intl Phone Number
    separateDialCode = true;
    // SearchCountryField = SearchCountryField;
    // CountryISO = CountryISO;
    // selectedCountry = CountryISO.Romania;
    // PhoneNumberFormat = PhoneNumberFormat;
    // preferredCountries: CountryISO[] = [CountryISO.Romania];

    constructor(private fb: FormBuilder, private projectsService: ProjectsService,
                private router: Router, private route: ActivatedRoute) {
    }


    ngOnInit(): void {

        // Select 2
        this.singleOption = {
            width: '100%',
        };
        this.multipleOption = {
            width: '100%',
            multiple: true,
            tags: true,
            placeholder: 'Click to add products'
        };


        this.getAllClients();
        this.getAllContracts();
        this.responsibleCompany();
        this.getUsersProductsList();
        this.currentUserData();


        this.loadProject();
    }

    // changePreferredCountries() {
    //     this.preferredCountries = [CountryISO.India, CountryISO.Canada];
    // }
    //

    currentUserData() {
        this.projectsService.getCurrentUser().subscribe((data: any) => {
            this.currentUser = data;
        });
    }

    getAllClients() {
        this.projectsService.getClients().subscribe((clientsData: any) => {
            this.clientsArray = clientsData;
        });
    }

    selectedClient(clientData) {
        // Get client info by id
        if (clientData !== '') {
            
            this.clientsArray.forEach((client: any) => {
                if (client.id === clientData) {
                    // Set the information for the following inputs
                    this.formGroup.get('clientName').patchValue(client.firstName + ' ' + client.lastName);
                    this.formGroup.get('clientEmail').patchValue(client.email);
                    this.formGroup.get('clientPhone').patchValue(client.phone);

                    this.separateDialCode = false;
                    this.formGroup.get('clientName').disable();
                    this.formGroup.get('clientEmail').disable();
                    this.formGroup.get('clientPhone').disable();
                    // this.selectedCountry = null;
                }
            });
        } else {
            this.separateDialCode = true;
            this.formGroup.get('clientName').enable();
            this.formGroup.get('clientEmail').enable();
            this.formGroup.get('clientPhone').enable();
            this.formGroup.get('clientName').patchValue('');
            this.formGroup.get('clientEmail').patchValue('');
            this.formGroup.get('clientPhone').patchValue('');
            // this.selectedCountry = CountryISO.Romania;
        }
    }

    getUsersProductsList() {
        this.projectsService.getUsersProducts().subscribe((data: any) => {
            data.forEach((product: any) => {
                this.productsArray.push({id: product.id, text: product.productTitle});
            });
            this.productsLoaded = true;
        });
    }

    // TODO Prima varianta selectate trebuie sa fie userlul logat
    responsibleCompany() {
        this.projectsService.getAllUsers().subscribe((userData: any) => {
            userData.forEach(user => {
                this.companyResponsibleArray.push({
                    id: user.id,
                    text: user.firstName + ' ' + user.lastName
                });
            });
            this.companyResponsibleLoaded = true;
        });
    }

    getAllContracts() {
        this.projectsService.getAllContracts().subscribe((contractsData: any) => {
            contractsData.forEach(data => {
                this.contractsArray.push({id: data.id, text: data.name});
                this.loadContracts = true;
            });
        });
    }


    loadProject() {
        const sb = this.route.paramMap.pipe(
            switchMap(params => {
                // get id from URL
                this.id = params.get('id');
                if (this.id) {
                    this.separateDialCode = false;
                    return this.projectsService.getProjectById(this.id);
                }
                return of(EMPTY_PROJECT);
            }),
            catchError((errorMessage) => {
                return of(undefined);
            }),
        ).subscribe((res: SingleProjectModel) => {

            this.project = res;
            this.loadForm();
        });
        this.subscriptions.push(sb);
    }

    // Custom validator
    checkDateDifference(control: AbstractControl): ValidatorFn {

        // Set form value in variables
        const startDate = control.get('startDate').value;
        const endDate = control.get('deadline').value;

        // If Start Date is bigger then End Date, then throw error
        if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
            control.get('startDate').setErrors({startDateIsBiggerThanEndDate: true});
        } else {
            if (startDate === undefined || startDate === null || startDate === '') {
                control.get('startDate').setErrors({isEmpty: true});
            } else {
                control.get('startDate').setErrors(null);
            }
        }
        return;
    }

    loadForm() {
        if (!this.project) {
            return;
        }

        const emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
        const phonePattern = '\\+?[0-9]{0,3}0[0-9]{6,9}';

        this.formGroup = this.fb.group({
            projectName: [this.project.projectName, Validators.required],
            startDate: [this.project.startDate, Validators.required],
            deadline: [this.project.deadline, Validators.required],
            clientId: [this.project.clientId],
            docNumber: [this.project.docNumber],
            contract: [this.project.contract],
            fiscalBill: [this.project.fiscalBill],
            responsibleUserId: [this.project.responsibleUserId],
            clientName: [this.project.clientName],
            clientEmail: [this.project.clientEmail, Validators.email],
            clientPhone: [this.project.clientPhone],
            staff: [this.project.staff],
            description: [this.project.description],
            budget: [this.project.budget, Validators.min(0)],
            status: [this.project.status],
            productList: [this.project.productList],
            stage: [this.project.stage],
            attachments: [this.project.attachments],
            tasks: [this.project.tasks]
        }, {validators: this.checkDateDifference});

        if (this.id) {
            this.formGroup.get('clientId').disable();
            this.formGroup.get('clientName').disable();
            this.formGroup.get('clientEmail').disable();
            this.formGroup.get('clientPhone').disable();
        }

        this.formLoaded = true;

    }


    save() {
        this.formGroup.markAllAsTouched();
        this.scrollTop();
        if (this.formGroup.valid) {
            // folosim getRawValue ca sa putem lua valorile din campurile disabled
            const formValues = this.formGroup.getRawValue();
            if (formValues.clientPhone?.e164Number) {
                // nr de tel a fost introdus
                this.project = {...formValues, clientPhone: formValues.clientPhone.e164Number};
            } else {
                // nr de tel NU a fost introdus
                this.project = {...formValues, clientPhone: ''};
            }


            if (this.id) {
                this.editProject();
            } else {
                this.createProject();
            }
        } else {
            this.feedbackMsg('error', 'Please fill out the required fields');
        }
    }

    editProject() {
        this.projectsService.editProject(this.id, this.project).subscribe((data: any) => {
            this.router.navigate(['/projects/list']);

        }, error => {
            
            this.feedbackMsg('error', 'Something went wrong');
        });
    }

    createProject() {
        this.projectsService.createProject(this.project).subscribe((data: any) => {
            this.createdProjectId = data.reason;

            this.router.navigate(['/projects/list']);

        }, error => {
            
            this.feedbackMsg('error', 'Something went wrong');
        });
    }

    // helpers for View
    isControlInvalid(controlName: string): boolean {
        const control = this.formGroup.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }

    controlHasError(validation: string, controlName: string) {
        const control = this.formGroup.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    scrollTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    // FeedBack Msg
    feedbackMsg(type, message) {
        if (type === 'success') {
            this.formSent = true;
            this.formResponse = true;
            this.successMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);

        } else if (type === 'error') {
            this.formSent = true;
            this.formResponse = false;
            this.errorMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }

}
